import { render, staticRenderFns } from "./QualityAssuranceComponentRequest.vue?vue&type=template&id=72019340&"
import script from "./QualityAssuranceComponentRequest.vue?vue&type=script&lang=js&"
export * from "./QualityAssuranceComponentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports